import { toast } from 'sonner';

import { ProjectFormDialog } from './project-form-dialog';
import {
  EMPTY_PROJECT_FORM,
  toCreateProjectPayload,
  type ProjectFormValues,
} from './project-schemas';
import { useCreateProject } from './projects-queries';

export interface CreateProjectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Create a project.
 *
 * Authorship comes from the session now (Phase 2), so the submit handler just
 * builds the payload and posts it — the server derives `createdBy` from who is
 * signed in. Access is gated at the button that opens this dialog: only a
 * Designer or Admin sees it (spec matrix), and the API enforces the rest.
 */
export const CreateProjectDialog = ({
  open,
  onOpenChange,
}: CreateProjectDialogProps) => {
  const createProject = useCreateProject();

  const handleSubmit = async (values: ProjectFormValues): Promise<boolean> => {
    const project = await createProject.mutateAsync(
      toCreateProjectPayload(values),
    );

    toast.success(`Created “${project.name}”.`);
    return true;
  };

  return (
    <ProjectFormDialog
      open={open}
      onOpenChange={onOpenChange}
      title="New project"
      description="A project groups the prototypes that belong to one piece of work."
      submitLabel="Create project"
      pendingLabel="Creating…"
      defaultValues={EMPTY_PROJECT_FORM}
      onSubmit={handleSubmit}
    />
  );
};
